angular.module('filters').filter('eventTime', function() {
  return function(event) {
    var end, start;
    start = moment(event.start, 'YYYY/MM/DD HH:mm').format('h:mma');
    end = moment(event.end, 'YYYY/MM/DD HH:mm').format('h:mma');
    return `${start} - ${end}`;
  };
});
